// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"h6","modalBox":"h6","modal-mask":"h7","modalMask":"h7","close-btn":"h8","closeBtn":"h8","container":"h9","content":"h-","title":"h_","subTitle":"ia","detail":"ib"};